// @ts-nocheck
import React from 'react';
import CommonForm from '../../../../components/hoc/common/handbook/CommonForm';
import { StyledInputNumber } from '../../../../components/hoc/common/components/elements';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { FormField } from '../../../../components/Form';
import { MonthPicker } from '../../../../components/ant/DayjsDatePicker';
import { createMonthDate, getBusinessCalendarMonth } from '../../../../lib/date/dayjs';
export default props => {
  return <CommonForm {...props}>
      {({
      values,
      setFieldValue
    }) => {
      const monthDate = values.year && values.month + 1 ? createMonthDate(values.year, values.month) : null;
      const maxDayCount = monthDate ? monthDate.daysInMonth() : 0;
      return <>
            <Grid gutter="16px" cols={5}>
              <GridItem>
                <FormField label="Дата" required name="month" fast>
                  {() => <MonthPicker value={monthDate || undefined} format={'MMMM YYYY'} placeholder="Выберите дату" onChange={value => {
                if (!value) return;
                const month = getBusinessCalendarMonth(value);
                setFieldValue('daysInMonth', month.daysInMonth || undefined);
                setFieldValue('year', month.year || undefined);
                setFieldValue('month', month.month !== undefined ? month.month : undefined);
              }} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Количество дней в месяце" name="daysInMonth" fast>
                  {({
                value,
                name
              }) => <StyledInputNumber disabled name={name} value={value} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Количество рабочих дней в месяце" name="workingDaysInMonth" fast>
                  {({
                value,
                name
              }) => <StyledInputNumber disabled name={name} value={value} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Количество рабочих часов в месяце" name="workingHoursInMonth" fast>
                  {({
                value,
                name
              }) => <StyledInputNumber disabled name={name} value={value} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Количество выходных дней в месяце" required name="dayOffsInMonth" fast>
                  {({
                value,
                name
              }) => <StyledInputNumber disabled={!maxDayCount} name={name} value={value} max={maxDayCount} onChange={value => {
                setFieldValue(name, value);
                setFieldValue('workingDaysInMonth', maxDayCount - (value || 0));
                setFieldValue('workingHoursInMonth', (maxDayCount - (value || 0)) * 8);
              }} />}
                </FormField>
              </GridItem>
            </Grid>
          </>;
    }}
    </CommonForm>;
};
